import Loading from '../../components/Loading';

import CheckData from '../../components/CatchError';
import DataTable from '../../components/Datatable';
import Component from '../../components/Component';
import Chart from './CountryTimeline';
import { COLUMNS } from './keys';
import query from './query';
import { scrollForTable } from '../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.searchFunction = this.searchFunction.bind(this);
        this.setCountry = this.setCountry.bind(this);
        this.query = query;
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.setState({ country: this.state.data?.[0]?.country });
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.country?.toLowerCase().includes(search.toLowerCase()));
    }

    setCountry(country) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        this.setState({
            country,
        });
    }

    render() {
        const { t } = this.props;

        if (this.state.loading && !this.state.loadMore) {
            return <Loading padding={10} />;
        }

        const sortFns = {
            country: (array) => array.sort((a, b) => a.country.localeCompare(b.country)),
            sumImpressions: (array) => array.sort((a, b) => a.sumImpressions - b.sumImpressions),
            sumClicks: (array) => array.sort((a, b) => a.sumClicks - b.sumClicks),
            avgCTR: (array) =>
                array.sort(
                    (a, b) => a.sumClicks / a.sumImpressions - b.sumClicks / b.sumImpressions,
                ),
        };

        const extraBtns = () => (
            <div className="table-header-subtitle">
                <div className="countries-information">
                    <i className="icon-info-circle" />
                    <div className="countries-information-header">
                        {t('discover.countries.table.message.title')}
                    </div>
                    <div className="countries-information-body">
                        {t('discover.countries.table.message.text')}
                    </div>
                </div>
            </div>
        );

        const header = (
            <div className="d-flex gap-8">
                {t('discover.countries.chart.header')}
                <button
                    id="dropdownCountry"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="country-dropdown-btn"
                >
                    {this.state.country}
                    <i className="icon-fi_chevron-down" />
                </button>
                <div
                    className="dropdown-menu country-dropdown-menu"
                    aria-labelledby="dropdownCountry"
                    id="dropdown-country"
                >
                    <div className="dropdown-menu-body">
                        {this.state.data?.map((item) => (
                            <div
                                className={`dropdown-country-item ${
                                    item.country === this.state.country ? 'active' : ''
                                }`}
                                key={item.country}
                                onClick={() => this.setCountry(item.country)}
                            >
                                {item.country}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
        return (
            <>
                {this.state.country && (
                    <div className="row card-row d-flex">
                        <div className="col-12">
                            <div className="card rounded-main overflow-hidden " id="domain-summery">
                                <div className="card-body">
                                    <Chart country={this.state.country} header={header} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="row card-row">
                    <div className="col-12">
                        <div className="card table-main rounded-main overflow-hidden">
                            <CheckData
                                content_id={this.props.content_id}
                                parent_id={this.props.parent_id}
                                data={this.state.data}
                                loading={this.state.loading}
                            >
                                <DataTable
                                    nodes={this.state.data}
                                    sortFns={sortFns}
                                    COLUMNS={COLUMNS(this.setCountry, this.state.country, t)}
                                    uniqKey={'country'}
                                    fileName={t('discover.countries.table.header')}
                                    extraBtns={extraBtns}
                                    header={t('discover.countries.table.header')}
                                    searchFunction={this.searchFunction}
                                    forceRun={this.forceRun}
                                    openRowUnderSelectedRow={this.state.country}
                                    additionalStyles={{
                                        Table: `
                                                --data-table-library_grid-template-columns :  minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                                ${scrollForTable}
                                            `,
                                        BaseCell: `font-family: 'Raleway';
                                                        font-weight: 500;
                                                        font-size: 16px;
                                                        line-height: 19px;
                                                        padding: 16px 10px !important;
                                                        color: #0D182C;
                                                    
                                                    
                                                        &.underline {
                                                            text-decoration: underline;
                                                        }
                                                        `,
                                    }}
                                />
                            </CheckData>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(Summary);
